<div class="p-3 rounded-3">
    <div class="row mb-2">
        <div class="col-12 mb-3">
            <div class="titletoptables d-flex justify-content-between align-items-center w-100">
                <div class="d-flex align-items-center">
                    <div class="leftsideicons">
                        <img src="../../assets/image/multiple-users.png" alt="multiuser" />
                    </div>
                    <h3 class="mb-0">
                        {{ "Client Directory" }}
                    </h3>
                </div>
                <button type="button" class="btn btn-primary addBtn"
                    (click)="openClientDirectoryDialog(null)">Add
                    Client Directory</button>
            </div>
        </div>
    </div>
    <div class="grid-card">
        <div class="filters-bar">
            <div class="filter-search">
                <app-search-input [value]="searchString" (valueChange)="filterData($event)" (cleared)="clearList()"></app-search-input>
            </div>
        </div>
        <app-data-grid>
        <kendo-grid #grid [loading]='kendoLoading' [data]=" gridData" [filter]="state.filter"
            [sortable]="{mode: 'single'}" [columnMenu]="{ filter: true }" [pageSize]="state.take" [skip]="state.skip"
            [pageable]="gridData?.data?.length && gridData.data.length > 0 ? pageableWithAll : false"
            (pageChange)="pageChange($event)" [sort]="sort"
            (sortChange)="clientDirectoryData ? sortChange($event): null" [resizable]="true" [reorderable]="true"
            filterable="menu" [filter]="state.filter" [selectable]="true"
            (columnVisibilityChange)="onColumnVisibilityChange(grid)"
            (dataStateChange)="clientDirectoryData ? dataStateChange($event): null" [navigable]="true"
            [groupable]="true" [group]="state.group" [height]="gridHeight" (cellClick)="onCellClick($event)">
             <kendo-grid-column field="Action" [width]="40" title=" " [includeInChooser]="false" [sortable]="false" [groupable]="false"
                [filterable]="false" [columnMenu]="false">
                <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
                    <div class="text-center">
                        <div class="mx-2 d-inline-block">
                            <button class="verical_menu" type="button" id="dropdownMenuButton1"
                                data-bs-toggle="dropdown" aria-expanded="false">
                                <svg class="vertical" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                                    <circle cx="12" cy="5" r="2"></circle>
                                    <circle cx="12" cy="12" r="2"></circle>
                                    <circle cx="12" cy="19" r="2"></circle>
                                </svg>
                            </button>
                            <ul class="dropdown-menu grid-action-menu" aria-labelledby="dropdownMenuButton1">
                                <li class="cursor-pointer">
                                    <a class="dropdown-item" (keydown.enter)="openClientDirectoryDialog(dataItem)"
                                        (click)="openClientDirectoryDialog(dataItem)">
                                        <kendo-svg-icon [icon]="icons.edit"></kendo-svg-icon>Edit</a>
                                </li>
                                 <li class="cursor-pointer">
                                    <a class="dropdown-item" (keydown.enter)="openDomainConvertDialog(dataItem)"
                                        (click)="openDomainConvertDialog(dataItem)">
                                        <kendo-svg-icon [icon]="icons.createDomain"></kendo-svg-icon>Create Domain</a>
                                </li>
                                <li class="cursor-pointer">
                                    <a class="dropdown-item">
                                        <mat-slide-toggle class="toggle" [(ngModel)]="dataItem.IsDoctorDirectoryEnable"
                                            *ngIf="!dataItem.IsAdmin" (change)="onToggleStatus(dataItem)">
                                        </mat-slide-toggle>Active</a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="Name" [width]="100" title="Name">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <span>{{dataItem.Salutation ?? ''}} {{dataItem.Name}}</span>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="ClinicName" [width]="100" title="Clinic Name">
            </kendo-grid-column>
            <kendo-grid-column field="Email" [width]="100" title="Email">
            </kendo-grid-column>
            <kendo-grid-column field="MobileNumber" [width]="100" title="Mobile Number">
            </kendo-grid-column>
            <kendo-grid-column field="City" [width]="100" title="City">
            </kendo-grid-column>
            <kendo-grid-column field="State" [width]="100" title="State">
            </kendo-grid-column>
            <kendo-grid-column field="Address" [width]="100" title="Address">
            </kendo-grid-column>
            <kendo-grid-column field="Education" [width]="100" title="Education">
            </kendo-grid-column>
            <kendo-grid-column field="Certificate" [width]="100" title="Certificate">
            </kendo-grid-column>
            <kendo-grid-column field="ExperienceValue" [width]="100" title="Experience" filter="numeric">
            </kendo-grid-column>
            <kendo-grid-column field="ConsultationFees" [width]="100" title="Consultation Fees" filter="numeric">
            </kendo-grid-column>
            <kendo-grid-column [width]="100" title="Clinic Time" [groupable]="false">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <span [innerHTML]="dataItem.ClinicTimeDisplay"></span>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column [width]="100" title="Services" [groupable]="false">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <span [innerHTML]="dataItem.ServiceDisplay"></span>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column [width]="100" title="Specialization" [groupable]="false">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <span [innerHTML]="dataItem.SpecializationDisplay"></span>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column [width]="100" title="Languages" [groupable]="false">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <span [innerHTML]="dataItem.LanguagesDisplay"></span>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="Memberships" [width]="100" title="Memberships">
            </kendo-grid-column>
        </kendo-grid>
        </app-data-grid>
    </div>
</div>
<ng-template #clientDirectoryDialog>
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="popup-title">{{action}} Client Directory</h4>
                <div class="header-actions">
                    <button mat-icon-button (click)="toggleMaximize()">
                        <mat-icon style="margin-top:-22px;">{{ isMaximized ? 'fullscreen_exit' : 'fullscreen'
                            }}</mat-icon>
                    </button>
                    <button type="button" class="btn-close" aria-label="Close" (click)="closeDialog()"></button>
                </div>
            </div>
            <div class="modal-body mat-dialog-content">
                <mat-dialog-content>
                    <form [formGroup]="addClientDirectoryFrom">
                        <div class="row">
                            <div class="col-4 col-md-1 col-lg-2 kt-margin-bottom-20-mobile py-2">
                                <div class="form-group">
                                    <label class="app-field-label">Salutation</label>
                                    <mat-form-field class="example-full-width custom-blue">
                                        <mat-select formControlName="Salutation" placeholder="Select Salutation"
                                            [panelClass]="'custom-select-panel'"
                                            [disableOptionCentering]="true">
                                            <mat-option value="Dr.">Dr.</mat-option>
                                            <mat-option value="Mr.">Mr.</mat-option>
                                            <mat-option value="Mrs.">Mrs.</mat-option>
                                            <mat-option value="Ms.">Ms.</mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                            </div>
                            <div class="col-4 col-md-2 col-lg-2 kt-margin-bottom-20-mobile py-2">
                                <div class="form-group">
                                    <label class="app-field-label">Name<span class="app-field-required">*</span></label>
                                    <mat-form-field class="example-full-width custom-blue">
                                        <input matInput type="text" formControlName="Name" maxlength="100" required />
                                        <mat-error
                                            *ngIf="addClientDirectoryFrom.get('Name')?.errors?.['required'] || addClientDirectoryFrom.get('Name')?.errors?.['whitespace']">
                                            Name is required
                                        </mat-error>
                                        <mat-error *ngIf="addClientDirectoryFrom.get('Name')?.errors?.['maxlength']">
                                            Max 100 characters allowed
                                        </mat-error>
                                        <mat-error *ngIf="addClientDirectoryFrom.get('Name')?.errors?.['invalidName']">
                                            Name can only contain letters, spaces, dot (.), hyphen (-) and
                                            apostrophe(').
                                        </mat-error>
                                    </mat-form-field>
                                </div>
                            </div>
                            <div class="col-4 col-md-4 col-lg-4 kt-margin-bottom-20-mobile py-2">
                                <div class="form-group">
                                    <label class="app-field-label">Clinic Name<span class="app-field-required">*</span></label>
                                    <mat-form-field class="example-full-width custom-blue">
                                        <input matInput type="text" formControlName="ClinicName" maxlength="250"
                                            required />
                                        <mat-error
                                            *ngIf="addClientDirectoryFrom.get('ClinicName')?.errors?.['required'] || addClientDirectoryFrom.get('ClinicName')?.errors?.['whitespace']">
                                            Clinic Name is required
                                        </mat-error>
                                        <mat-error
                                            *ngIf="addClientDirectoryFrom.get('ClinicName')?.errors?.['maxlength']">Max
                                            50 characters allowed</mat-error>
                                    </mat-form-field>
                                </div>
                            </div>
                            <div class="col-4 col-md-4 col-lg-4 kt-margin-bottom-20-mobile py-2">
                                <div class="form-group">
                                    <label class="app-field-label">Email<span class="app-field-required">*</span></label>
                                    <mat-form-field class="example-full-width custom-blue">
                                        <input matInput type="text" formControlName="Email"
                                            (keyup)="handleBlurEmail($event)" required />
                                        <mat-error *ngIf="addClientDirectoryFrom.get('Email')?.errors?.['required']">
                                            Email is required</mat-error>
                                        <mat-error *ngIf="addClientDirectoryFrom.get('Email')?.errors?.['pattern']">
                                            Invalid email format</mat-error>
                                        <mat-error *ngIf="addClientDirectoryFrom.get('Email')?.errors?.['emailExists']">
                                            Email already exists, please use a different Email
                                        </mat-error>
                                    </mat-form-field>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-4 py-2">
                                <label class="app-field-label">Mobile Number<span class="app-field-required">*</span></label>
                                <mat-form-field class="example-full-width custom-blue">
                                    <input matInput type="text" formControlName="MobileNumber"
                                        (keypress)="keyPress($event)" maxlength="15" required />
                                    <mat-error *ngIf="addClientDirectoryFrom.get('MobileNumber')?.errors?.['required']">
                                        Mobile Number is required
                                    </mat-error>
                                    <mat-error *ngIf="addClientDirectoryFrom.get('MobileNumber')?.errors?.['pattern']">
                                        Only digits are allowed
                                    </mat-error>
                                    <mat-error
                                        *ngIf="addClientDirectoryFrom.get('MobileNumber')?.errors?.['minlength']">
                                        Mobile number must be at least 10 digits.
                                    </mat-error>
                                    <mat-error
                                        *ngIf="addClientDirectoryFrom.get('MobileNumber')?.errors?.['maxlength']">
                                        Mobile number cannot exceed 15 digits.
                                    </mat-error>
                                </mat-form-field>
                            </div>
                            <div class="col-md-4 py-2">
                                <label class="app-field-label">Address<span class="app-field-required">*</span></label>
                                <mat-form-field class="example-full-width custom-blue">
                                    <input matInput type="text" formControlName="Address" #search
                                        placeholder="Enter Address" required />
                                    <mat-error
                                        *ngIf="addClientDirectoryFrom.get('Address')?.errors?.['required'] || addClientDirectoryFrom.get('Address')?.errors?.['whitespace']">
                                        Address is required
                                    </mat-error>
                                </mat-form-field>
                            </div>

                            <div class="col-md-4 py-2">
                                <label class="app-field-label">State<span class="app-field-required">*</span></label>
                                <mat-form-field class="example-full-width custom-blue">
                                    <input matInput type="text" formControlName="State" placeholder="Enter State"
                                        required />
                                    <mat-error
                                        *ngIf="addClientDirectoryFrom.get('State')?.errors?.['required'] || addClientDirectoryFrom.get('State')?.errors?.['whitespace']">
                                        State is required
                                    </mat-error>
                                </mat-form-field>
                            </div>
                        </div>

                        <!-- Row 3 -->
                        <div class="row">
                            <div class="col-md-4 py-2">
                                <div class="row">
                                    <div class="col-md-12">
                                        <div class="form-group position-relative w-100 custom-mat-style"
                                            #wrapper_category>
                                            <label class="floating-label" [class.active]="labelActive_category"
                                                for="categoryDropdown">
                                                Specialization Category *
                                            </label>
                                            <button id="categoryDropdown" type="button"
                                                class="form-control text-start d-flex justify-content-between align-items-center dropdown-toggle"
                                                (click)="toggleDropdown_category($event)"
                                                (focusin)="onButtonFocus_category()"
                                                (focusout)="onButtonBlur_category()">
                                                <span class="selected-text">
                                                    {{ selectedCategoryNames?.length ? selectedCategoryNames : '' }}
                                                </span>
                                            </button>
                                            <div class="custom-validation-wrapper">
                                                <mat-error class="custom-validation-msg"
                                                    *ngIf="addClientDirectoryFrom.get('CategorySpecializationIds')?.touched && addClientDirectoryFrom.get('CategorySpecializationIds')?.invalid">
                                                    Specialization Category is required
                                                </mat-error>
                                            </div>
                                            <ul class="dropdown-menu w-100 p-2 services-scroll"
                                                [class.show]="isDropdownOpen_category">
                                                <li class="mb-1">
                                                    <input type="text" class="form-control form-control-sm"
                                                        placeholder="Search..." (keyup)="filterCategories($event)" />
                                                </li>
                                                <li *ngFor="let category of filteredCategoryList">
                                                    <div class="form-check">
                                                        <input class="form-check-input" type="checkbox"
                                                            [id]="'cat-' + category.Id"
                                                            [checked]="isSelectedCategory(category)"
                                                            [disabled]="hasSelectedSpecializations(category.Id)"
                                                            (change)="toggleCategory(category, $event)" />
                                                        <label class="form-check-label" [for]="'cat-' + category.Id"
                                                            [class.text-muted]="hasSelectedSpecializations(category.Id)">
                                                            {{ category.Name }}
                                                        </label>
                                                    </div>
                                                </li>
                                                <li *ngIf="filteredCategoryList.length === 0"
                                                    class="text-center text-muted">
                                                    No data found
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-4 py-2">
                                <div class="row add-picker-row">
                                    <div class="col-md-9">
                                        <div class="form-group position-relative w-100 custom-mat-style"
                                            #wrapper_special>
                                            <label class="floating-label" [class.active]="labelActive_specialization"
                                                for="specializationDropdown">
                                                Specialization *
                                            </label>

                                            <button id="specializationDropdown" type="button"
                                                class="form-control text-start d-flex justify-content-between align-items-center dropdown-toggle"
                                                (click)="toggleDropdown_special($event)"
                                                (focusin)="onButtonFocus_special()" (focusout)="onButtonBlur_special()">
                                                <span class="selected-text">
                                                    {{
                                                    selectedSpecializationNames?.length
                                                    ? selectedSpecializationNames : '' }}
                                                </span>
                                            </button>
                                            <div class="custom-validation-wrapper">
                                                <mat-error class="custom-validation-msg"
                                                    *ngIf="showCategoryFirstError && addClientDirectoryFrom.get('CategorySpecializationIds')?.value.length === 0">
                                                    Please select Specialization Category first
                                                </mat-error>
                                                <mat-error class="custom-validation-msg"
                                                    *ngIf="addClientDirectoryFrom.get('CategorySpecializationIds')?.value.length > 0 && addClientDirectoryFrom.get('SpecializationIds')?.invalid">
                                                    Specialization is required
                                                </mat-error>
                                            </div>
                                            <ul class="dropdown-menu w-100 p-2 services-scroll"
                                                [class.show]="isDropdownOpen_specialization">
                                                <li class="mb-1">
                                                    <input type="text" class="form-control form-control-sm"
                                                        placeholder="Search..."
                                                        (keyup)="filterSpecializations($event)" />
                                                </li>

                                                <li *ngFor="let special of filteredSpecializationList">
                                                    <div class="form-check">
                                                        <input class="form-check-input" type="checkbox"
                                                            [id]="'special_' + special.Id" [value]="special.Id"
                                                            (change)="toggleSpecialization(special, $event)"
                                                            [checked]="isSelectedSpecialization(special)" />
                                                        <label class="form-check-label" [for]="'special_' + special.Id">
                                                            {{ special.Name }}
                                                        </label>
                                                    </div>
                                                </li>

                                                <li *ngIf="filteredSpecializationList.length === 0"
                                                    class="text-center text-muted">
                                                    No data found
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div class="col-md-3 px-1">
                                        <button type="button" class="btn btn-primary w-100 btn-height-38"
                                            (click)="openDialogForAddSpecialization(AddSpecialization)">
                                            Add
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-4 py-2">
                                <div class="row add-picker-row">
                                    <div class="col-md-9">
                                        <div class="form-group position-relative w-100 custom-mat-style"
                                            #wrapper_service>
                                            <label class="floating-label" [class.active]="labelActive_service"
                                                for="servicesDropdown">
                                                Services *
                                            </label>

                                            <button id="servicesDropdown" type="button"
                                                class="form-control text-start d-flex justify-content-between align-items-center dropdown-toggle"
                                                (click)="toggleDropdown_service($event)"
                                                (focusin)="onButtonFocus_service()" (focusout)="onButtonBlur_service()">
                                                <span class="selected-text">
                                                    {{
                                                    selectedServicesNames?.length
                                                    ? selectedServicesNames : '' }}
                                                </span>
                                            </button>
                                            <div class="custom-validation-wrapper">
                                                <mat-error class="custom-validation-msg"
                                                    *ngIf="addClientDirectoryFrom.get('ServicesIds')?.touched && addClientDirectoryFrom.get('ServicesIds')?.invalid">
                                                    Service is required
                                                </mat-error>
                                            </div>
                                            <ul class="dropdown-menu w-100 p-2 services-scroll"
                                                [class.show]="isDropdownOpen_service">
                                                <li class="mb-1">
                                                    <input type="text" class="form-control form-control-sm"
                                                        placeholder="Search..." (keyup)="filterServices($event)" />
                                                </li>
                                                <li *ngFor="let service of filteredServicesList">
                                                    <div class="form-check">
                                                        <input class="form-check-input" type="checkbox"
                                                            [id]="'service_' + service.Id" [value]="service.Id"
                                                            (change)="toggleService(service, $event)"
                                                            [checked]="isSelected(service)" />
                                                        <label class="form-check-label" [for]="'service_' + service.Id">
                                                            {{ service.Name }}
                                                        </label>
                                                    </div>
                                                </li>
                                                <li *ngIf="filteredServicesList.length === 0"
                                                    class="text-center text-muted">
                                                    No data found
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div class="col-md-3 px-1">
                                        <button type="button" class="btn btn-primary w-100 btn-height-38"
                                            (click)="openDialogForAddService(AddServices)">
                                            Add
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- Row 4 -->
                        <div class="row">
                            <div class="col-md-4 py-2">
                                <label class="app-field-label">Education<span class="app-field-required">*</span></label>
                                <mat-form-field class="example-full-width custom-blue">
                                    <input matInput type="text" formControlName="Education" required />
                                    <mat-error
                                        *ngIf="addClientDirectoryFrom.get('Education')?.errors?.['required'] || addClientDirectoryFrom.get('Education')?.errors?.['whitespace']">
                                        Education is required
                                    </mat-error>
                                </mat-form-field>
                            </div>
                            <div class="col-md-4 py-2">
                                <label class="app-field-label">Certificate</label>
                                <mat-form-field class="example-full-width custom-blue">
                                    <input matInput type="text" formControlName="Certificate" maxlength="1000" placeholder="e.g. Cert 1, Cert 2" />
                                    <mat-error *ngIf="addClientDirectoryFrom.get('Certificate')?.errors?.['maxlength']">
                                        Certificate cannot exceed 1000 characters.
                                    </mat-error>
                                </mat-form-field>
                            </div>
                            <div class="col-md-4 py-2">
                                <div class="d-flex align-items-center gap-2 mb-1">
                                    <mat-checkbox color="primary" formControlName="IsShowPrice"
                                        (change)="onIsShowPriceChange($event)">
                                    </mat-checkbox>
                                    <label class="app-field-label mb-0">Consultation Fees<span class="app-field-required">*</span></label>
                                </div>
                                <mat-form-field class="example-full-width custom-blue">
                                    <input matInput type="number" formControlName="ConsultationFees" min="0"
                                        required />
                                    <mat-error
                                        *ngIf="addClientDirectoryFrom.get('ConsultationFees')?.errors?.['required'] || addClientDirectoryFrom.get('ConsultationFees')?.errors?.['whitespace']">
                                        Consultation Fees is required
                                    </mat-error>
                                    <mat-error *ngIf="addClientDirectoryFrom.get('ConsultationFees')?.errors?.['min']">
                                        Consultation Fees must be a positive number.
                                    </mat-error>
                                </mat-form-field>
                            </div>
                        </div>
                        
                        <!-- Row 5 -->
                        <div class="row">
                            <div class="col-md-4 py-2">
                                <label class="app-field-label">Experience<span class="app-field-required">*</span></label>
                                <mat-form-field class="example-full-width custom-blue">
                                    <input matInput type="number" formControlName="Experience" min="0" required />
                                    <mat-error
                                        *ngIf="addClientDirectoryFrom.get('Experience')?.errors?.['required'] || addClientDirectoryFrom.get('Experience')?.errors?.['whitespace']">
                                        Experience is required
                                    </mat-error>
                                    <mat-error *ngIf="addClientDirectoryFrom.get('Experience')?.errors?.['min']">
                                        Experience must be a positive number.
                                    </mat-error>
                                </mat-form-field>
                            </div>
                            <div class="col-md-4 py-2">
                                <label class="app-field-label">Memberships</label>
                                <mat-form-field class="example-full-width custom-blue">
                                    <input matInput type="text" formControlName="Memberships" />
                                </mat-form-field>
                            </div>
                             <div class="col-md-4 py-2">
                                <label class="mb-2" for="gender-radio-group">Gender</label><br />
                                <mat-radio-group id="gender-radio-group" formControlName="Gender" class="pt-2">
                                    <mat-radio-button value="Male" class="mr-3">Male</mat-radio-button>
                                    <mat-radio-button value="Female">Female</mat-radio-button>
                                </mat-radio-group>
                            </div>
                        </div>

                        <!-- Row 6 -->
                        <div class="row">
                            <div class="col-md-4 py-2">
                                <div class="row align-items-center">
                                    <div class="col-md-7">
                                        <label class="mb-0 font-weight-bold" for="ClinicTiming">Days & Timing</label>
                                    </div>
                                    <div class="col-md-5">
                                        <button type="button" class="btn btn-primary btn-sm w-100"
                                            (click)="openDialogForAddTiming(AddClinicTiming)">
                                            Add Timing
                                        </button>
                                    </div>
                                    <div class="col-md-12 mt-2" *ngIf="doctorTimings && doctorTimings.length > 0">
                                        <div *ngFor="let timing of doctorTimings; let i = index">
                                            <span class="d-block font-size-13" *ngIf="timing.FromTime && timing.ToTime">
                                                {{ timing.FromDay }} - {{ timing.ToDay }}
                                                : {{ timing.FromTime | date : "HH:mm" }} - {{ timing.ToTime | date :
                                                "HH:mm" }}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                               <div class="col-md-4 py-2">
                                <div class="row add-picker-row">
                                    <div class="col-md-9">
                                        <div class="form-group position-relative w-100 custom-mat-style"
                                            #wrapper_language>
                                            <label class="floating-label" [class.active]="labelActive_language"
                                                for="languagesDropdown">
                                                Languages
                                            </label>

                                            <button id="languagesDropdown" type="button"
                                                class="form-control text-start d-flex justify-content-between align-items-center dropdown-toggle"
                                                (click)="toggleDropdown_language($event)"
                                                (focusin)="onButtonFocus_language()" (focusout)="onButtonBlur_language()">
                                                <span class="selected-text">
                                                    {{
                                                    selectedLanguagesNames?.length
                                                    ? selectedLanguagesNames : '' }}
                                                </span>
                                            </button>
                                            <ul class="dropdown-menu w-100 p-2 services-scroll"
                                                [class.show]="isDropdownOpen_language">
                                                <li class="mb-1">
                                                    <input type="text" class="form-control form-control-sm"
                                                        placeholder="Search..." (keyup)="filterLanguages($event)" />
                                                </li>
                                                <li *ngFor="let language of filteredLanguagesList">
                                                    <div class="form-check">
                                                        <input class="form-check-input" type="checkbox"
                                                            [id]="'language_' + language.Id" [value]="language.Id"
                                                            (change)="toggleLanguage(language, $event)"
                                                            [checked]="isSelectedLanguage(language)" />
                                                        <label class="form-check-label" [for]="'language_' + language.Id">
                                                            {{ language.Name }}
                                                        </label>
                                                    </div>
                                                </li>
                                                <li *ngIf="filteredLanguagesList.length === 0"
                                                    class="text-center text-muted">
                                                    No data found
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div class="col-md-3 px-1">
                                        <button type="button" class="btn btn-primary w-100 btn-height-38"
                                            (click)="openDialogForAddLanguage(AddLanguage)">
                                            Add
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Row 7 -->
                        <div class="row">
                             <div class="col-md-4 py-2">
                                <label class="app-field-label">Description</label>
                                <mat-form-field class="example-full-width custom-blue">
                                    <textarea matInput formControlName="Description" rows="2"></textarea>
                                </mat-form-field>
                            </div>
                        </div>
                        <div class="row mt-3">
                            <div class="col-md-12 py-2">
                                <mat-label>Profile Photo</mat-label><br />
                                <input #Myfile type="file" (change)="onFileChange($event)"
                                    class="btn btn-secondary btn-elevate kt-login__btn-primary p-2" />
                                <p class="mb-0">{{ profileName }}</p>
                            </div>
                            <div class="col-md-12" *ngIf="profileUrl">
                                <div class="form-group ms-2 picture-container">
                                    <img [src]="profileUrl"
                                        class="img-fluid rounded shadow profile-client-img picture-img" alt="Profile" />
                                    <button *ngIf="profileUrl" class="remove-picture-btn" (click)="removeImage()">
                                        X
                                    </button>
                                </div>
                            </div>
                        </div>
                        <!-- Clinic Media Upload Row -->
                        <div class="row mt-3">
                            <div class="col-md-12 py-2">
                                <label class="mb-2 font-weight-bold">Clinic Photos & Videos (Maximum 6)</label><br />
                                <input type="file" (change)="onClinicMediaFileChange($event)" multiple accept="image/*,video/mp4"
                                    class="btn btn-secondary btn-elevate kt-login__btn-primary p-2 w-100" />
                                <span class="text-muted d-block mt-1" style="font-size: 11px;">
                                    Max size: Image (PNG, JPG, JPEG, GIF, WEBP) - 5MB | Video (MP4) - 30MB
                                </span>
                            </div>
                            <div class="col-md-12 mt-2" *ngIf="clinicMediaList && clinicMediaList.length > 0">
                                <div class="d-flex flex-wrap" style="gap: 10px;">
                                    <ng-container *ngFor="let media of clinicMediaList; let idx = index">
                                        <div *ngIf="!media.IsDeleted" class="position-relative border rounded p-1" style="width: 100px; height: 100px; display: inline-block;">
                                            <!-- Image Preview -->
                                            <img *ngIf="media.MediaType === 1" [src]="media.Url" class="img-fluid rounded" style="width: 100%; height: 100%; object-fit: cover;" />
                                            <!-- Video Preview / Icon -->
                                            <div *ngIf="media.MediaType === 2" class="d-flex flex-column align-items-center justify-content-center bg-light rounded" style="width: 100%; height: 100%;">
                                                <span class="badge bg-danger text-white mb-1">VIDEO</span>
                                                <span class="text-muted text-truncate font-size-10 px-1" style="max-width: 90px;">{{ media.FileName }}</span>
                                            </div>
                                            <!-- Remove Button -->
                                            <button type="button" class="btn btn-danger btn-xs position-absolute" style="top: 2px; right: 2px; padding: 0px 5px; font-size: 10px; line-height: 1.5; border-radius: 3px;" (click)="removeClinicMedia(idx)">
                                                X
                                            </button>
                                        </div>
                                    </ng-container>
                                </div>
                            </div>
                        </div>
                    </form>
                </mat-dialog-content>
                <mat-dialog-actions align="end">
                    <button mat-raised-button (click)="closeDialog()" style="margin-right: 10px;" type="button"
                        class="btn btn-secondary" tabindex="-1">Cancel</button>
                    <button mat-raised-button type="button" class="btn btn-primary"
                        (click)="submitClientDirectory()">{{this.action}}</button>
                </mat-dialog-actions>
            </div>
        </div>
    </div>
</ng-template>
<ng-template #AddServices>
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="popup-title mb-0">
                    Add Services
                </h4>
                <div class="header-actions">
                    <button type="button" class="btn-close" aria-label="Close" (click)="closeServiceDialog()">
                    </button>
                </div>
            </div>
            <form class="diagSave" [formGroup]="servicesForm" (ngSubmit)="addServices(servicesForm)" autocomplete="off">
                <div class="modal-body">
                    <mat-dialog-content>
                        <div class="row">
                            <div class="col-12">
                                <div class="form-group">
                                    <label class="app-field-label">Name<span class="app-field-required">*</span></label>
                                    <mat-form-field class="w-100">
                                        <input type="text" matInput formControlName="Name" required />
                                        <mat-error *ngIf="(servicesForm.controls['Name'].hasError('required') &&
                      servicesForm.controls['Name'].touched) || servicesForm.controls['Name'].untouched">
                                            Required
                                        </mat-error>
                                    </mat-form-field>
                                </div>
                            </div>
                        </div>
                    </mat-dialog-content>
                </div>
                <mat-dialog-actions align="end">
                    <button mat-raised-button style="margin-right: 10px;" type="button" class="btn btn-secondary"
                        (click)="closeServiceDialog()">
                        Cancel
                    </button>

                    <button mat-raised-button type="submit" class="btn btn-primary">
                        Save
                    </button>
                </mat-dialog-actions>
            </form>
        </div>
    </div>
</ng-template>
<ng-template #AddLanguage>
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="popup-title mb-0">
                    Add Language
                </h4>
                <div class="header-actions">
                    <button type="button" class="btn-close" aria-label="Close" (click)="closeLanguageDialog()">
                    </button>
                </div>
            </div>
            <form class="diagSave" [formGroup]="languagesForm" (ngSubmit)="addLanguage(languagesForm)"
                autocomplete="off">
                <div class="modal-body">
                    <mat-dialog-content>
                        <div class="row">
                            <div class="col-12">
                                <div class="form-group">
                                    <label class="app-field-label">Name<span class="app-field-required">*</span></label>
                                    <mat-form-field class="w-100">
                                        <input type="text" matInput formControlName="Name" required />
                                        <mat-error *ngIf="(languagesForm.controls['Name'].hasError('required') &&
                      languagesForm.controls['Name'].touched) || languagesForm.controls['Name'].untouched">
                                            Required
                                        </mat-error>
                                    </mat-form-field>
                                </div>
                            </div>
                        </div>
                    </mat-dialog-content>
                </div>
                <mat-dialog-actions align="end">
                    <button mat-raised-button style="margin-right: 10px;" type="button" class="btn btn-secondary"
                        (click)="closeLanguageDialog()">
                        Cancel
                    </button>

                    <button mat-raised-button type="submit" class="btn btn-primary">
                        Save
                    </button>
                </mat-dialog-actions>
            </form>
        </div>
    </div>
</ng-template>
<ng-template #AddSpecialization>
    <div class="modal-dialog">
        <div class="modal-content">

            <div class="modal-header">
                <h4 class="popup-title mb-0">Add Specialization</h4>

                <div class="header-actions">
                    <button type="button" class="btn-close" aria-label="Close" (click)="closeSpecializationDialog()">
                    </button>
                </div>
            </div>
            <form class="diagSave" [formGroup]="specializationForm" (ngSubmit)="addSpecialization(specializationForm)"
                autocomplete="off">
                <div class="modal-body">
                    <mat-dialog-content>
                        <div class="row">
                            <div class="col-12">
                                <div class="form-group">
                                    <label class="app-field-label">Specialization Category<span class="app-field-required">*</span></label>
                                    <mat-form-field class="w-100">
                                        <mat-select formControlName="CategorySpecializationId"
                                            placeholder="Select Specialization Category"
                                            [panelClass]="'custom-select-panel'" [disableOptionCentering]="true"
                                            required>
                                            <mat-option *ngFor="let cat of categoryList" [value]="cat.Id">
                                                {{ cat.Name }}
                                            </mat-option>
                                        </mat-select>
                                        <mat-error
                                            *ngIf="specializationForm.get('CategorySpecializationId')?.errors?.['required']">
                                            Category is required
                                        </mat-error>
                                    </mat-form-field>
                                </div>
                            </div>
                            <div class="col-12">
                                <div class="form-group">
                                    <label class="app-field-label">Name<span class="app-field-required">*</span></label>
                                    <mat-form-field class="w-100">
                                        <input type="text" matInput formControlName="Name" required />
                                        <mat-error *ngIf="specializationForm.get('Name')?.hasError('required')">
                                            Specialization name is required
                                        </mat-error>
                                    </mat-form-field>
                                </div>
                            </div>
                        </div>
                    </mat-dialog-content>
                </div>
                <mat-dialog-actions align="end" class="mt-3">
                    <button mat-raised-button type="button" class="btn btn-secondary"
                        (click)="closeSpecializationDialog()">
                        Cancel
                    </button>
                    <button mat-raised-button type="submit" class="btn btn-primary">
                        Save
                    </button>
                </mat-dialog-actions>
            </form>
        </div>
    </div>
</ng-template>
<ng-template #AddClinicTiming>
    <div class="modal-dialog">
        <div class="modal-content">

            <div class="modal-header">
                <h4 class="popup-title mb-0">
                    Add Timing
                </h4>

                <div class="header-actions">
                    <button mat-raised-button type="button" class="btn btn-primary"
                        (click)="onAddClick(timingArray.length - 1)">
                        + Add
                    </button>
                </div>
            </div>

            <form class="diagSave" *ngIf="timingForm" [formGroup]="timingForm" autocomplete="off">

                <div class="modal-body">

                    <mat-dialog-content>

                        <div formArrayName="ClinicTimings">

                            <div *ngFor="let timing of timingArray.controls; let i = index; let last = last"
                                [formGroupName]="i" class="form-group row">

                                <div class="col-md-2">
                                    <label class="mb-2 font-weight-bold app-field-label" for="fromDay">
                                        From Day
                                    </label>

                                    <select class="form-control" id="fromDay" formControlName="fromDay">

                                        <option value="" disabled>
                                            Select from day
                                        </option>

                                        <option *ngFor="let day of weekDays" [value]="day">

                                            {{ day }}

                                        </option>

                                    </select>
                                </div>

                                <div class="col-md-2">
                                    <label class="mb-2 font-weight-bold app-field-label" for="toDay">
                                        To Day
                                    </label>

                                    <select class="form-control" id="toDay" formControlName="toDay">

                                        <option value="" disabled>
                                            Select to day
                                        </option>

                                        <option *ngFor="let day of weekDays" [value]="day">

                                            {{ day }}

                                        </option>

                                    </select>
                                </div>

                                <div class="col-md-3">
                                    <label class="mb-2 font-weight-bold" for="fromTime">
                                        Start Time
                                    </label>

                                    <kendo-timepicker formControlName="fromTime" [format]="'HH:mm'" class="mt-1"
                                        (valueChange)="onTimeChange(i)">

                                    </kendo-timepicker>
                                </div>

                                <div class="col-md-3">
                                    <label class="mb-2 font-weight-bold" for="toTime">
                                        Close Time
                                    </label>

                                    <kendo-timepicker formControlName="toTime" [format]="'HH:mm'" class="mt-1"
                                        (valueChange)="onTimeChange(i)">

                                    </kendo-timepicker>
                                </div>

                                <div class="col-md-2 d-flex flex-column justify-content-end align-items-center mb-2">
                                    <button type="button" class="btn-close" aria-label="Close"
                                        (click)="removeTimingRow(i)">
                                    </button>
                                </div>

                                <div class="col-4"></div>

                                <div class="col-8">
                                    <div *ngIf="timing.errors?.['invalidTime']" class="invalid-feedback d-block">

                                        Start time must be less than close time

                                    </div>
                                </div>

                                <div class="col-12">
                                    <hr />
                                </div>

                            </div>

                        </div>

                    </mat-dialog-content>

                </div>

                <mat-dialog-actions align="end">

                    <button mat-raised-button style="margin-right: 10px;" type="button" class="btn btn-secondary"
                        (click)="cancelTimingDialog()">

                        Cancel

                    </button>

                    <button mat-raised-button style="margin-right: 10px;" type="button" class="btn btn-primary"
                        (click)="saveTimingDialog()">

                        Okay

                    </button>

                </mat-dialog-actions>

            </form>

        </div>
    </div>
</ng-template>
<ng-template #updateStatusDialog>
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="popup-title">Update Status</h4>
                <button type="button" class="btn-close" aria-label="Close" mat-dialog-close
                    (click)="Noupdate()"></button>
            </div>
            <div class="modal-body">
                <mat-dialog-content>
                    <div>Are you sure you want to update status?</div>
                </mat-dialog-content>
                <mat-dialog-actions align="end">
                    <button mat-raised-button style="margin-left: 20px;" type="button" class="btn btn-secondary"
                        tabindex="-1" (click)="Noupdate()" mat-dialog-close>No</button>
                    <button mat-raised-button type="button" (click)="updateStatus()" class="btn btn-primary"
                        tabindex="0">Yes</button>
                </mat-dialog-actions>
            </div>
        </div>
    </div>
</ng-template>
<ng-template #domainConvertDialog>
    <div class="d-flex justify-content-between">
        <h4 class="dialog-title">Create Domain</h4>
        <div class="dialog-controls">
            <button type="button" class="btn-close" aria-label="Close" mat-dialog-close></button>
        </div>
    </div>
    <div class="pt-3">
        <form class="kt-form" [formGroup]="domainForm" autocomplete="off">
            <div class="row">
                <div class="col-4 col-md-2 col-lg-2 kt-margin-bottom-20-mobile py-2">
                    <div class="form-group">
                        <label class="app-field-label">Salutation</label>
                        <mat-form-field class="example-full-width custom-blue">
                            <mat-select formControlName="Salutation" placeholder="Select Salutation"
                                [panelClass]="'custom-select-panel'"
                                [disableOptionCentering]="true">
                                <mat-option value="Dr.">Dr.</mat-option>
                                <mat-option value="Mr.">Mr.</mat-option>
                                <mat-option value="Mrs.">Mrs.</mat-option>
                                <mat-option value="Ms.">Ms.</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>
                <div class="col-8 col-md-4 col-lg-4 kt-margin-bottom-20-mobile py-2">
                    <div class="form-group">
                        <label class="app-field-label">Doctor Name<span class="app-field-required">*</span></label>
                        <mat-form-field class="example-full-width custom-blue">
                            <input matInput type="text" formControlName="FirstName" autocomplete="off" maxlength="100"
                                required />
                            <mat-error *ngIf="isControlHasError('FirstName', 'required')">
                                This field is required
                            </mat-error>
                            <mat-error *ngIf="domainForm.get('FirstName')?.hasError('trimError')">
                                Can not contain space
                            </mat-error>
                            <mat-error *ngIf="isControlHasError('FirstName', 'maxlength')">
                                This field is required only 100 characters
                            </mat-error>
                            <mat-error *ngIf="isControlHasError('FirstName', 'invalidName')">
                                Name can only contain letters, spaces, dot (.), hyphen (-) and apostrophe
                                (').</mat-error>
                        </mat-form-field>
                    </div>
                </div>
                <div class="col-12 col-md-6 col-lg-6 kt-margin-bottom-20-mobile py-2">
                    <div class="form-group">
                        <label class="app-field-label">Clinic Name<span class="app-field-required">*</span></label>
                        <mat-form-field class="example-full-width custom-blue">
                            <input matInput pattern="^[A-Za-z\s][A-Za-z0-9\s]*$" type="text"
                                formControlName="CompanyName" autocomplete="off" maxlength="250"
                                (keyup)="handleBlurName()" required />
                            <mat-error *ngIf="isControlHasError('CompanyName', 'required')">
                                This field is required
                            </mat-error>
                            <mat-error *ngIf="domainForm.get('CompanyName')?.hasError('trimError')">
                                Can not contain space
                            </mat-error>
                            <mat-error *ngIf="isControlHasError('CompanyName', 'pattern')">
                                Can not start with Numeric and cannot add Speacial
                                characters
                            </mat-error>
                            <mat-error *ngIf="isControlHasError('CompanyName', 'maxlength')">
                                This field is required only 250 characters
                            </mat-error>
                        </mat-form-field>
                        <mat-error *ngIf="error">
                            Clinic name already exist, please use different clinic
                            name or if you forgot your clinic name then please use
                            forgot password.
                        </mat-error>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12 col-md-12 col-lg-12 kt-margin-bottom-20-mobile py-2">
                    <div class="form-group">
                        <label class="app-field-label">Clinic Domain Name<span class="app-field-required">*</span></label>
                        <mat-form-field class="example-full-width custom-blue" style="width: 70%">
                            <input matInput pattern="^[A-Za-z\s][A-Za-z0-9\s]*$" type="text"
                                formControlName="CompanyCode" autocomplete="off" maxlength="100"
                                (keyup)="handleBlurCompanyCode()" required />
                            <mat-error *ngIf="isControlHasError('CompanyCode', 'required')">
                                This field is required
                            </mat-error>
                            <mat-error *ngIf="domainForm.get('CompanyCode')?.hasError('trimError')">
                                Can not contain space
                            </mat-error>
                            <mat-error *ngIf="isControlHasError('CompanyCode', 'pattern')">
                                Can not start with Numeric and cannot add Special
                                characters
                            </mat-error>
                            <mat-error *ngIf="isControlHasError('CompanyCode', 'maxlength')">
                                This field is required only 100 characters
                            </mat-error>
                        </mat-form-field>
                        <span style="font-weight: 600">{{ domainName }}</span>
                        <mat-error *ngIf="companycodeerror">
                            Domain name already exist, please use different domain
                            name.
                        </mat-error>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12 col-md-6 col-lg-6 kt-margin-bottom-20-mobile py-2">
                    <div class="form-group">
                        <label class="app-field-label">Email<span class="app-field-required">*</span></label>
                        <mat-form-field class="example-full-width custom-blue">
                            <input matInput type="text" formControlName="Email" autocomplete="off" maxlength="50"
                                (keyup)="handleBlurEmailbyId($event,selectedDoctor.Id)" required />

                            <mat-error *ngIf="isControlHasError('Email', 'required')">
                                This field is required
                            </mat-error>

                            <mat-error *ngIf="isControlHasError('Email', 'pattern')">
                                follow standard email pattern
                            </mat-error>
                            <mat-error *ngIf="emailerror">
                                Email already exist, please use different Email.
                            </mat-error>
                        </mat-form-field>
                    </div>
                </div>
                <div class="col-12 col-md-6 col-lg-6 kt-margin-bottom-20-mobile py-2">
                    <div class="form-group">
                        <label class="app-field-label">Password<span class="app-field-required">*</span></label>
                        <mat-form-field class="example-full-width custom-blue">
                            <input matInput [type]="hide ? 'password' : 'text'" formControlName="Password" required>
                            <mat-icon matSuffix (click)="hide = !hide" (keydown.enter)="hide = !hide">{{hide ?
                                'visibility_off' : 'visibility'}}
                            </mat-icon>
                            <mat-error *ngIf="isControlHasError('Password', 'required')">
                                This field is required
                            </mat-error>
                            <mat-error *ngIf="domainForm.get('Password')?.hasError('trimError')">
                                Can not contain space
                            </mat-error>
                            <mat-error *ngIf="isControlHasError('Password', 'minlength')">
                                Password must be at least 6 characters
                            </mat-error>
                        </mat-form-field>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12 col-md-6 col-lg-6 kt-margin-bottom-20-mobile py-2">
                    <div class="form-group">
                        <label class="app-field-label">Phone Number<span class="app-field-required">*</span></label>
                        <mat-form-field class="example-full-width custom-blue">
                            <input matInput type="text" (keypress)="keyPress($event)"
                                (ngModelChange)="onPhoneNumberKeyup()" formControlName="PhoneNumber" autocomplete="off"
                                required />
                            <mat-error *ngIf="isControlHasError('PhoneNumber', 'required')">
                                This field is required
                            </mat-error>
                            <mat-error *ngIf=" domainForm.get('PhoneNumber')?.hasError('invalidPhone')">
                                Invalid phone number
                            </mat-error>
                            <mat-error *ngIf="domainForm.get('PhoneNumber')?.hasError('trimError')">
                                Can not contain space
                            </mat-error>
                        </mat-form-field>
                    </div>
                </div>
                <div class="col-12 col-md-6 col-lg-6 kt-margin-bottom-20-mobile py-2">
                    <div class="form-group">
                        <label class="app-field-label">Country<span class="app-field-required">*</span></label>
                        <mat-form-field class="example-full-width custom-blue">
                            <mat-select formControlName="CurrencyId" placeholder="Select Country"
                                [panelClass]="'custom-select-panel'"
                                [disableOptionCentering]="true">
                                <mat-option *ngFor="let item of currencyList" [value]="item.Id">{{
                                    item.CountryName
                                    }}</mat-option>
                            </mat-select>
                            <mat-error *ngIf="isControlHasError('CurrencyId', 'required')">
                                This field is required
                            </mat-error>
                        </mat-form-field>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12 col-md-12 col-lg-12 kt-margin-bottom-20-mobile py-2">
                    <div class="form-group">
                        <label class="app-field-label">Clinic Address<span class="app-field-required">*</span></label>
                        <mat-form-field class="example-full-width custom-blue w-100">
                            <input matInput formControlName="CompanyAddress" placeholder="Search for location"
                                autocorrect="off" autocapitalize="off" spellcheck="off" type="text"
                                class="form-control address-search" #searchAdd required />
                            <mat-error *ngIf="isControlHasError('CompanyAddress', 'required')">
                                This field is required
                            </mat-error>
                        </mat-form-field>
                    </div>
                </div>

            </div>
            <mat-dialog-actions align="end">
                <button style="display: flex;gap: 20px;" (click)="convertDomain()" id="kt_login_signin_submit"
                    [class.spinner]="loading" class="btn btn-primary btn-elevate kt-login__btn-primary ml-2"
                    [disabled]=" !domainForm.valid || error || emailerror || companycodeerror || isInProgress || loading">
                    Submit
                </button>
            </mat-dialog-actions>
        </form>
    </div>
</ng-template>